import script from "./OverviewOdds.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewOdds.vue?vue&type=script&setup=true&lang=js"

import "./OverviewOdds.vue?vue&type=style&index=0&id=7f934370&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f934370"]])

export default __exports__